import CommonProps from "../CommonProps";
import React from "react";
import './Slider.scss';

interface SliderProps extends CommonProps {
    isOn: boolean;
    isRound?: boolean;
    onChange: (on: boolean) => void;
}

const Slider = (props: SliderProps) => {

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e.target.checked);
    }

    return (
        <>
            <div className="slider-wrapper">
                <label className="slider">
                    <input data-testid={props["data-testid"] || 'slider'}
                           aria-label={props["aria-label"] || 'slider'}
                           type="checkbox"
                           checked={props.isOn}
                           onChange={(e) => onChange(e)}/>
                    <div className={`slider-box ${props.isRound ? 'round' : ''}`}></div>
                </label>
            </div>
        </>
    );
}

export default Slider;